import { render, staticRenderFns } from "./relevant-case.vue?vue&type=template&id=e705b1be&scoped=true&"
import script from "./relevant-case.vue?vue&type=script&lang=js&"
export * from "./relevant-case.vue?vue&type=script&lang=js&"
import style0 from "./relevant-case.vue?vue&type=style&index=0&id=e705b1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e705b1be",
  null
  
)

export default component.exports